import React from "react";
import { Paper, Button, Typography } from "@mui/material";
import { Call, Email, DeleteOutline, MedicalServices } from "@mui/icons-material";
import { ReactComponent as Doctoricon } from "../../Images/Doctorcolor.svg";
import GroupIcon from "@mui/icons-material/Group";

const DoctorsListSection = (props) => {
  const { doctorData, selectedView, onAddDoctor, onDeleteDoctor } = props;
  const isDoctor = selectedView === "doctors";
  const title = isDoctor ? "Doctors list" : "Nurses list";
  const buttonText = isDoctor ? "Add Doctor" : "Add Nurse";
  const entityLabel = isDoctor ? "Doctor" : "Nurse";

  return (
    <Paper elevation={0} className="figma-wrapper">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-2">
          {isDoctor ? (
            <MedicalServices fontSize="small" />
          ) : (
            <GroupIcon fontSize="small" />
          )}
          <span className="fw-semibold">{title}</span>
        </div>

        <Button
          className="add_doctor"
          startIcon={
            isDoctor ? (
              <Doctoricon style={{ color: "#4F46E5", width: 18 }} />
            ) : (
              <GroupIcon style={{ fill: "#fff", width: 18 }} />
            )
          }
          onClick={onAddDoctor}
        >
          {buttonText}
        </Button>
      </div>

      {/* DOCTORS LIST */}
      {doctorData && doctorData.length > 0 ? (
        doctorData.map((doc, index) => (
          <div className="figma-card" key={doc.id || index}>
            <div className="row align-items-center">
              {/* Doctor/Nurse Name */}
              <div className="col-lg-3 d-flex align-items-center gap-3">
                <div
                  // className="doc-icon"
                  className={`doc-icon${isDoctor ? "" : " doc-icon-green"}`}
                >
                  {isDoctor ? (
                    <Doctoricon
                      sx={{
                        fontSize: 25,
                        "& path": {
                          fill: "#4F46E5",
                        },
                      }}
                    />
                  ) : (
                    <GroupIcon
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                      }}
                    />
                  )}
                </div>
                <div>
                  <div className="doc-name">{doc?.doctor_name || "N/A"}</div>
                  <div className="doc-role">{doc?.designation || "N/A"}</div>
                </div>
              </div>

              {/* Contact */}
              <div className="col-lg-2">
                <div className="figma-text">
                  <Call fontSize="small" /> {doc?.phone_number || "N/A"}
                </div>
                <div className="figma-sub">
                  <Email fontSize="small" /> {doc?.email || "N/A"}
                </div>
              </div>

              {/* HPR / Registration Details */}
              <div className="col-lg-2">
                <div className="figma-text">
                  • HPR ID : {doc?.hpr_id || "N/A"}
                </div>
                <div className="figma-sub">
                  • Registration No : {doc?.reg_number || "N/A"}
                </div>
              </div>

              {/* Registration Year/State */}
              <div className="col-lg-2">
                <div className="figma-text">
                  • Registration Year : {doc?.reg_year || "N/A"}
                </div>
                <div className="figma-sub">
                  • Registration State : {doc?.state_name || "N/A"}
                </div>
              </div>

              {/* Posting */}
              <div className="col-lg-2">
                <div className="figma-text">
                  • Type : {doc?.type || "N/A"}
                </div>
                <div className="figma-sub">
                  • {doc?.insource_outsource === "Outsource"
                    ? `Visiting From: ${doc?.visiting_from || "N/A"}`
                    : doc?.insource_outsource || "N/A"}
                </div>
              </div>

              {/* Status + Delete INLINE */}
              <div className="col-lg-1 d-flex align-items-center gap-2 justify-content-end">
                {doc?.is_active === 1 && (
                  <DeleteOutline
                    className="delete-icon"
                    onClick={() => onDeleteDoctor(doc?.doc_id)}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-4">
          <Typography variant="body2" color="textSecondary">
            No {entityLabel.toLowerCase()}s found
          </Typography>
        </div>
      )}
    </Paper>
  );
};

export default DoctorsListSection;